import { render } from "./Calendar.vue?vue&type=template&id=7498d72b&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"

import "./Calendar.vue?vue&type=style&index=0&id=7498d72b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7498d72b"

export default script